// extracted by mini-css-extract-plugin
export default {"loader":"loader___FaotP","spin":"spin___Pql2W"};